// getters.js

export default {
    getConditionsList(state){
        return state.conditionsList
    },
};
